<template>
  <div class="dock-control-panel">
    <!-- 标题栏 -->
    <div class="dock-control-panel-header">
      <span class="header-title">设备操作 {{ dockName }}</span>
      <span class="close-btn" @click="closeControlPanel">
        <CloseOutlined />
      </span>
    </div>

    <!-- 设备设置 -->
    <DeviceSettingBox :sn="sn" :deviceInfo="deviceInfo"></DeviceSettingBox>

    <!-- 设备属性新增设置 -->
    <div class="device-set-add" v-if="dock3Show">
      <div class="set-add-item">
        <div class="set-add-item-left">
          <div class="item-label">
            部署
            <a-tooltip placement="top">
              <template #title>
                <div>您可以在大疆行业 APP上切换部署模式</div>
              </template>
              <InfoCircleOutlined class="info-icon" />
            </a-tooltip>
          </div>
        </div>
        <div class="set-add-item-right">
          <DeviceSettingPopover
            :visible="setcarInfo.visible"
            :loading="setcarInfo.loading"
            @confirm="onCarConfirm"
            @cancel="onCarCancel"
            :okText="'一键标定'"
          >
            <template #formContent>
              <div class="car-content">
                <div class="car-section-title">场地评估</div>
                <div class="car-section">
                  <div class="network-info">
                    <span class="text-secondary">机场</span>
                    <span class="divider">|</span>
                    <span>{{
                      (deviceInfo.dock?.basic_osd?.network_state?.rate ?? 0) > 0
                        ? (deviceInfo.dock?.basic_osd?.network_state?.rate ?? 0) + "KB/s"
                        : ""
                    }}</span>
                  </div>
                  <div class="car-flex">
                    <div class="car-flex-item">
                      <div class="flex-item-value">
                        <img :src="rtkImg" alt="RTK" class="rtk-icon" />
                        {{ deviceInfo.dock?.basic_osd?.positionState?.rtk_number }}
                      </div>
                      <div class="flex-item-label">机场搜星</div>
                    </div>
                    <div class="car-flex-item">
                      <div class="flex-item-value">
                        <span v-if="deviceInfo.dock?.basic_osd?.positionState?.is_fixed === 0">未收敛</span>
                        <span v-else-if="deviceInfo.dock?.basic_osd?.positionState?.is_fixed === 1">收敛中</span>
                        <span v-else-if="deviceInfo.dock?.basic_osd?.positionState?.is_fixed === 2">已收敛</span>
                        <span v-else-if="deviceInfo.dock?.basic_osd?.positionState?.is_fixed === 3" class="text-error">收敛失败</span>
                      </div>
                      <div class="flex-item-label">位置收敛</div>
                    </div>
                  </div>
                </div>
                <div class="car-section deployment-section">
                  <div class="car-section-title">部署设置</div>
                  <div class="car-flex">
                    <div class="car-flex-item">
                      <div class="flex-item-value">
                        <span
                          v-if="deviceInfo.dock?.basic_osd?.alternate_land_point?.is_configured === 0"
                          class="text-error"
                        >未设置</span>
                        <span v-else-if="deviceInfo.dock?.basic_osd?.alternate_land_point?.is_configured === 1">已设置</span>
                      </div>
                      <div class="flex-item-label">相对备降点</div>
                    </div>
                    <div class="car-flex-item">
                      <div class="flex-item-value">
                        <span
                          v-if="deviceInfo.dock?.basic_osd?.positionState?.is_calibration === 0"
                          class="text-error"
                        >未标定</span>
                        <span v-else-if="deviceInfo.dock?.basic_osd?.positionState?.is_calibration === 1">已标定</span>
                      </div>
                      <div class="flex-item-label">机场标定</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div style="display: flex;">
              <span>车载部署</span>
              <a class="edit-btn" @click="onShowCarPopConfirm">
                <EditOutlined />
              </a>
            </div>
          </DeviceSettingPopover>
        </div>
      </div>
    </div>

    <!-- 控制指令 -->
    <div class="control-cmd-wrapper">
      <div class="control-cmd-header">
        <div class="debug-section">
          <span class="debug-label">远程调试</span>
          <a-switch
            class="debug-switch"
            checked-children="开"
            un-checked-children="关"
            v-model:checked="debugStatus"
            @change="onDeviceStatusChange"
          />
        </div>
        <div>
          <a-button
            size="small"
            type="primary"
            class="test-fly-btn"
            @click="dockTryFly"
            :disabled="deviceInfo?.dock?.basic_osd?.mode_code === 4"
          >
            机场试飞
            <a-tooltip placement="top">
              <template #title>
                <div>
                  快速验证机场状态。点击机场试飞，自动创建计划，本设备将垂直飞至60m高、云台俯仰角向下90度拍照后返航。
                </div>
              </template>
              <InfoCircleOutlined class="info-icon-inline" />
            </a-tooltip>
          </a-button>
        </div>
      </div>

      <div class="control-cmd-box">
        <!-- 基础控制指令 -->
        <div
          v-for="(cmdItem, index) in cmdList"
          :key="cmdItem.cmdKey"
          class="control-cmd-item"
          v-show="cmdItem.show"
        >
          <div class="control-cmd-item-left">
            <div class="item-label">{{ cmdItem.status }}</div>
            <div class="item-status-cmd">{{ cmdItem.label }}</div>
          </div>
          <div class="control-cmd-item-right">
            <a-button
              :disabled="!debugStatus || cmdItem.disabled"
              :loading="cmdItem.loading"
              size="small"
              type="primary"
              @click="sendControlCmd(cmdItem, index)"
            >
              {{ cmdItem.operateText }}
            </a-button>
            <a-button
              v-if="!dock1Show && cmdItem.label === '舱盖' && cmdItem.status === '开'"
              :disabled="!debugStatus"
              size="small"
              type="primary"
              class="force-close-btn"
              @click="forcedClose"
            >
              强制关闭
            </a-button>
          </div>
        </div>

        <!-- 新增远程调试功能 -->
        <div
          class="control-cmd-item"
          v-for="(cmdItem, index) in addCmdList"
          :key="index"
          v-show="cmdItem.show"
        >
          <div class="control-cmd-item-left">
            <div class="item-label">{{ cmdItem.status }}</div>
            <div class="item-status-cmd">{{ cmdItem.label }}</div>
          </div>
          <div class="control-cmd-item-right">
            <a-button
              :disabled="!debugStatus"
              :loading="cmdItem.loading"
              size="small"
              type="primary"
              @click="addControlCmd(cmdItem, index)"
            >
              {{ cmdItem.operateText }}
            </a-button>
          </div>
        </div>

        <!-- 机场空调 -->
        <div class="dock-aircondition">
          <div class="aircondition-title">机场空调：{{ airconditionName }}</div>
          <div class="aircondition-controls">
            <a-radio-group
              v-model:value="aircondition"
              button-style="solid"
              size="small"
              :disabled="!debugStatus"
              @change="sendAirs"
            >
              <a-radio-button :value="0" class="air-btn">空闲</a-radio-button>
              <a-radio-button :value="1" class="air-btn">制冷</a-radio-button>
              <a-radio-button :value="2" class="air-btn">制热</a-radio-button>
              <a-radio-button :value="3" class="air-btn">除湿</a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup lang="ts">
import {
  defineProps,
  defineEmits,
  ref,
  watch,
  onMounted,
  reactive,
  onUnmounted,
  computed,
  createVNode,
} from "vue";
import {
  CloseOutlined,
  InfoCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { useDockControl } from "./use-dock-control";
import { DeviceInfoType } from "/@/types/device";
import DeviceSettingPopover from "./DeviceSettingPopover.vue";
import rtkImg from "/@/assets/icons/rtks.png";

import {
  cmdList as baseCmdList,
  DeviceCmdItem,
  DeviceCmd,
} from "/@/types/device-cmd";
import { useMyStore } from "/@/store";
import {
  updateDeviceCmdInfoByOsd,
  updateDeviceCmdInfoByExecuteInfo,
} from "/@/utils/device-cmd";
import DeviceSettingBox from "./DeviceSettingBox.vue";
import {
  testFlightApi,
  silentModeApi,
  getDeviceTopo,
  setRtkApi,
  forceCloseApi,
  getAirImgApi,
  setAirImgApi,
} from "/@/api/manage";
import { ELocalStorageKey } from "/@/types";
import { message, Modal } from "ant-design-vue";

const props = defineProps<{
  sn: string;
  deviceInfo: DeviceInfoType;
  dockName: string;
}>();
const emit = defineEmits<{
  (e: "close-control-panel", sn: string): void;
}>();

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
const store = useMyStore();
const initCmdList = baseCmdList.map((cmdItem) => Object.assign({}, cmdItem));
const cmdList = ref(initCmdList);
const addCmdList = ref([
  {
    label: "静音模式",
    status: "未开启",
    operateText: "开启",
    cmdKey: "silent_mode",
    func: "silentMode",
    silentmode: 0,
    loading: false,
    show: true,
  },
  {
    label: "图片空中回传",
    status: "关",
    operateText: "开启",
    cmdKey: "img_mode",
    func: "imgMode",
    loading: false,
    silentmode: 0,
    show: true,
  },
]);

const airconditionName = ref<string>("空闲");
const aircondition = ref<number>(0);
const times = ref<number | undefined>();
const debugStatus = ref(false);
const stopWatchList = ref<Array<() => void>>([]);
const snArr = ref<string[]>([]);
const setcarInfo = reactive({
  visible: false,
  loading: false,
});
const deviceAll = ref<any[]>([]);

stopWatchList.value.push(
  watch(
    () => store?.state.AirState.data,
    (data) => {
      if (data && data.length > 0) {
        data.forEach((item: any) => {
          if (item.sn === props.sn) {
            const currentTime = Date.now();
            if (!times.value || currentTime >= times.value) {
              aircondition.value = item.value;
              airconditionName.value = item.name;
            }
          }
        });
      }
    },
    {
      deep: true,
      immediate: true,
    }
  )
);
const dock3Show = computed(() => {
  const devices = deviceAll.value.filter(
    (item: any) => item.device_sn === props.sn
  );
  return devices.length > 0 && devices[0]?.device_name === "DJI Dock3";
});

const dock1Show = computed(() => {
  const devices = deviceAll.value.filter(
    (item: any) => item.device_sn === props.sn
  );
  return devices.length > 0 && devices[0]?.device_name === "DJI Dock";
});

function judgeDockType(dockType: string): boolean {
  const devices = deviceAll.value.filter(
    (item: any) => item.device_sn === props.sn
  );
  return devices.length > 0 && devices[0]?.device_name === dockType;
}
async function getOnlineTopo() {
  try {
    const res = await getDeviceTopo(workspaceId);
    if (res.code === 0) {
      deviceAll.value = res.data;
      getImgMode();
    }
  } catch (error) {
    console.error("获取设备拓扑失败:", error);
  }
}

onMounted(() => {
  getOnlineTopo();
});

stopWatchList.value.push(
  watch(
    () => props.deviceInfo,
    (value: DeviceInfoType) => {
      const osdInfos = {
        dock: value.dock,
        device: value.device,
        gateway: value.gateway,
      };

      if (!snArr.value.includes(props.sn)) {
        snArr.value.push(props.sn);
      }

      const isDock1 = judgeDockType("DJI Dock");

      cmdList.value.forEach((item) => {
        item.show = true;
        if (item.cmdKey === DeviceCmd.PutterOpen) {
          item.show = isDock1;
        }
      });

      updateDeviceCmdInfoByOsd(cmdList.value, osdInfos);
      debugStatus.value = props.deviceInfo?.dock?.basic_osd?.mode_code === 2;

      // 处理静音状态 (使用 any 类型断言因为类型定义中缺少此属性)
      const basicOsd = value?.dock?.basic_osd as any;
      const isSilentMode = basicOsd?.silent_mode === 1;
      addCmdList.value[0] = {
        label: "静音模式",
        status: isSilentMode ? "已开启" : "未开启",
        operateText: isSilentMode ? "关闭" : "开启",
        cmdKey: "silent_mode",
        silentmode: isSilentMode ? 0 : 1,
        func: "silentMode",
        loading: false,
        show: true,
      };
    },
    {
      immediate: true,
      deep: true,
    }
  )
);
stopWatchList.value.push(
  watch(
    () => store?.state.devicesCmdExecuteInfo,
    (devicesCmdExecuteInfo) => {
      if (snArr.value.includes(props.sn) && devicesCmdExecuteInfo?.[props.sn]) {
        updateDeviceCmdInfoByExecuteInfo(
          cmdList.value,
          devicesCmdExecuteInfo[props.sn]
        );
      }
    },
    {
      immediate: true,
      deep: true,
    }
  )
);

function closeControlPanel() {
  emit("close-control-panel", props.sn);
}

const { sendDockControlCmd, dockDebugOnOff } = useDockControl();

async function onDeviceStatusChange(status: boolean) {
  const result = await dockDebugOnOff(props.sn, status);
  if (!result) {
    debugStatus.value = !status;
  }
}

async function sendControlCmd(cmdItem: DeviceCmdItem, index: number) {
  await sendDockControlCmd(
    {
      sn: props.sn,
      cmd: cmdItem.cmdKey,
      action: cmdItem.action,
    },
    true
  );
}

async function sendAirs(e: any) {
  const num = e.target.value;
  const params = {
    sn: props.sn,
    cmd: DeviceCmd.AirConditionerModeSwitch,
    action: num,
  };
  times.value = Date.now() + 2000;
  await sendDockControlCmd(params, true);
}

async function dockTryFly() {
  if (!props.sn) return;

  const dockMode = props.deviceInfo?.dock?.basic_osd?.mode_code;
  if (dockMode === 2) {
    message.warning("当前处于远程调试状态，请先关闭！");
    return;
  }

  try {
    const res = await testFlightApi(props.sn);
    if (res.code === 0) {
      message.success("机场试飞成功");
    }
  } catch (error) {
    console.error("机场试飞失败:", error);
  }
}
async function addControlCmd(cmdItem: any, index: number) {
  if (cmdItem.cmdKey === "silent_mode") {
    addCmdList.value[index].loading = true;
    addCmdList.value[index].status = cmdItem.silentmode ? "开启中..." : "关闭中...";
    const params = {
      dockSn: props.sn,
      mode: cmdItem.silentmode,
    };
    await silentModeApi(params);
  }

  if (cmdItem.cmdKey === "img_mode") {
    addCmdList.value[index].loading = true;
    addCmdList.value[index].status = cmdItem.silentmode ? "关闭中..." : "开启中...";
    const params = {
      dockSn: props.sn,
      b: !cmdItem.silentmode,
    };
    await imgModeClose(params);
  }
}

async function imgModeClose(params: any) {
  try {
    const res = await setAirImgApi(params);
    addCmdList.value[1].loading = false;
    if (res.code === 0) {
      await getImgMode();
    }
  } catch (error) {
    addCmdList.value[1].loading = false;
    console.error("图片回传操作失败:", error);
  }
}

async function getImgMode() {
  if (!props.sn) return;

  try {
    const params = { dockSn: props.sn };
    const res = await getAirImgApi(params);
    
    if (res.code === 0 && res.data) {
      const status = res.data.air_transfer_enable;
      addCmdList.value[1] = {
        ...addCmdList.value[1],
        status: status === 0 ? "未开启" : "已开启",
        operateText: status === 0 ? "开启" : "关闭",
        silentmode: status === 0 ? 0 : 1,
      };
    }

    const show = judgeDockType("DJI Dock");
    addCmdList.value[1].show = !show;
  } catch (error) {
    console.error("获取图片回传状态失败:", error);
  }
}

function forcedClose() {
  Modal.confirm({
    title: "提示",
    icon: createVNode(ExclamationCircleOutlined),
    content: "请确认飞行器不在舱内，否则可能导致桨叶被夹",
    centered: true,
    class: "modal-class",
    async onOk() {
      if (!props.sn) return;
      try {
        const res = await forceCloseApi(props.sn);
        if (res.code === 0) {
          message.success("关闭成功！");
        }
      } catch (error) {
        console.error("强制关闭失败:", error);
      }
    },
  });
}

function onShowCarPopConfirm() {
  setcarInfo.visible = true;
}

async function onCarConfirm() {
  const params = {
    sn: props.sn,
    lng: "",
    lat: "",
    height: "",
  };
  
  setcarInfo.loading = true;
  try {
    const res = await setRtkApi(params);
    if (res.code === 0) {
      message.success("一键标定成功");
      setcarInfo.visible = false;
    }
  } catch (error) {
    console.error("一键标定失败:", error);
  } finally {
    setcarInfo.loading = false;
  }
}

function onCarCancel() {
  setcarInfo.visible = false;
}

onUnmounted(() => {
  stopWatchList.value.forEach((stopWatch) => stopWatch());
  stopWatchList.value = [];
});
</script>
  
  <style lang="scss" scoped>
// 苹果深色设计风格配色
$bg-primary: #1c1c1e;
$bg-secondary: #2c2c2e;
$bg-tertiary: #3a3a3c;
$border-color: rgba(255, 255, 255, 0.1);
$border-hover: rgba(255, 255, 255, 0.2);
$text-primary: #ffffff;
$text-secondary: rgba(255, 255, 255, 0.6);
$text-tertiary: rgba(255, 255, 255, 0.4);
$accent-blue: #0a84ff;
$accent-red: #ff453a;
$accent-green: #32d74b;
$shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
$shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);
$radius-sm: 8px;
$radius-md: 12px;
$radius-lg: 16px;

.dock-control-panel {
  width: 420px;
  padding: 0;
  background: $bg-primary;
  color: $text-primary;
  border-radius: $radius-lg;
  box-shadow: $shadow-md;
  overflow: hidden;
  backdrop-filter: blur(20px);
  border: 1px solid $border-color;

  // 标题栏
  .dock-control-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    padding: 0 16px;
    background: $bg-secondary;
    border-bottom: 1px solid $border-color;

    .header-title {
      font-size: 15px;
      font-weight: 600;
      letter-spacing: -0.3px;
    }

    .close-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.2s ease;
      color: $text-secondary;

      &:hover {
        background: $bg-tertiary;
        color: $text-primary;
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  // 设备属性新增设置
  .device-set-add {
    background: $bg-secondary;
    padding: 8px 12px;
    margin: 8px 0;
    border-radius: $radius-sm;
    border: 1px solid $border-color;

    .set-add-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 10px;
      background: $bg-tertiary;
      border-radius: 6px;
      transition: all 0.2s ease;

      &:hover {
        background: lighten($bg-tertiary, 3%);
      }

      .set-add-item-left {
        .item-label {
          font-size: 13px;
          font-weight: 600;
          color: $text-primary;
          display: flex;
          align-items: center;
          gap: 4px;

          .info-icon {
            color: $text-secondary;
            font-size: 13px;
          }
        }
      }

      .set-add-item-right {
        display: flex;
        align-items: center;
        gap: 6px;

        .edit-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          color: $accent-blue;
          font-size: 15px;
          border-radius: 6px;
          transition: all 0.2s ease;
          cursor: pointer;

          &:hover {
            background: rgba($accent-blue, 0.1);
          }
        }
      }
    }
  }

  // 控制指令区域
  .control-cmd-wrapper {
    margin: 8px 0 0;
    background: $bg-secondary;
    border-radius: $radius-md;
    border: 1px solid $border-color;
    overflow: hidden;

    .control-cmd-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 12px;
      background: $bg-tertiary;
      border-bottom: 1px solid $border-color;

      .debug-section {
        display: flex;
        align-items: center;
        gap: 10px;

        .debug-label {
          font-size: 13px;
          font-weight: 600;
        }

        // .debug-switch {
        //   background: rgba(255, 255, 255, 0.1);
        // }
      }

      .test-fly-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        height: 28px;
        padding: 0 12px;
        background: $accent-blue;
        border: none;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover:not(:disabled) {
          background: lighten($accent-blue, 5%);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba($accent-blue, 0.3);
        }

        &:active:not(:disabled) {
          transform: translateY(0);
        }

        &:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        .info-icon-inline {
          font-size: 13px;
        }
      }
    }

    .control-cmd-box {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      padding: 6px;

      .control-cmd-item {
        flex: 1 1 calc(50% - 2px);
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 8px;
        background: $bg-tertiary;
        border: 1px solid $border-color;
        border-radius: 6px;
        transition: all 0.2s ease;

        &:hover {
          border-color: $border-hover;
          background: lighten($bg-tertiary, 2%);
        }

        .control-cmd-item-left {
          display: flex;
          flex-direction: column;
          gap: 2px;
          flex: 1;
          min-width: 0;

          .item-label {
            font-size: 13px;
            font-weight: 600;
            color: $text-primary;
          }

          .item-status-cmd {
            font-size: 11px;
            color: $text-secondary;
          }
        }

        .control-cmd-item-right {
          display: flex;
          gap: 6px;
          flex-shrink: 0;

          .ant-btn {
            height: 26px;
            // padding: 0 10px;
            padding-top: 0px;
            padding-bottom: 0px;
            font-size: 12px;
            border-radius: 5px;
            transition: all 0.2s ease;

            &:hover:not(:disabled) {
              transform: translateY(-1px);
            }

            &:active:not(:disabled) {
              transform: translateY(0);
            }
          }

          .force-close-btn {
            margin-left: 0;
          }
        }
      }

      // 机场空调
      .dock-aircondition {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 8px 10px;
        background: $bg-tertiary;
        border: 1px solid $border-color;
        border-radius: 6px;
        transition: all 0.2s ease;

        &:hover {
          border-color: $border-hover;
        }

        .aircondition-title {
          font-size: 13px;
          font-weight: 600;
          color: $text-primary;
        }

        .aircondition-controls {
          .ant-radio-group {
            display: flex;
            gap: 6px;
            width: 100%;

            .air-btn {
              flex: 1;
              text-align: center;
              height: 28px;
              line-height: 28px;
              padding: 0;
              border-radius: 5px;
              font-size: 12px;
              transition: all 0.2s ease;

              &:hover:not(.ant-radio-button-wrapper-disabled) {
                transform: translateY(-1px);
              }
            }
          }
        }
      }
    }
  }
}

// 车载部署弹窗内容
.car-content {
  padding: 2px 0;

  .car-section-title {
    font-size: 13px;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: 8px;
  }

  .car-section {
    margin-bottom: 12px;

    .network-info {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 6px 0;
      font-size: 12px;

      .divider {
        color: $text-tertiary;
      }
    }
  }

  .deployment-section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid $border-color;
  }

  .car-flex {
    display: flex;
    gap: 12px;

    .car-flex-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .flex-item-value {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        font-weight: 500;
        color: $text-primary;

        .rtk-icon {
          width: 16px;
          height: 16px;
        }
      }

      .flex-item-label {
        font-size: 11px;
        color: $text-secondary;
      }
    }
  }
}

// 通用样式类
.text-secondary {
  color: $text-secondary;
}

.text-tertiary {
  color: $text-tertiary;
}

.text-error {
  color: $accent-red;
  font-weight: 500;
}

.text-success {
  color: $accent-green;
  font-weight: 500;
}

// 覆盖 Ant Design 样式以匹配深色主题
:deep(.ant-btn-primary) {
  background: $accent-blue;
  border-color: $accent-blue;

  &:hover:not(:disabled) {
    background: lighten($accent-blue, 5%);
    border-color: lighten($accent-blue, 5%);
  }
}

:deep(.ant-switch) {
  background: rgba(255, 255, 255, 0.2);
  
  &.ant-switch-checked {
    background: $accent-blue;
  }
}

:deep(.ant-radio-button-wrapper) {
  background: $bg-tertiary;
  border-color: $border-color;
  color: $text-primary;

  &:hover {
    color: $accent-blue;
  }

  &.ant-radio-button-wrapper-checked {
    background: $accent-blue;
    border-color: $accent-blue;
    color: $text-primary;

    &:hover {
      background: lighten($accent-blue, 5%);
      border-color: lighten($accent-blue, 5%);
    }
  }

  // 移除按钮之间的分隔线
  &:not(:first-child)::before {
    display: none;
  }
  &:first-child {
    border-left: none;
  }
}

:deep(.ant-tooltip) {
  .ant-tooltip-inner {
    background: $bg-tertiary;
    border: 1px solid $border-color;
    border-radius: $radius-sm;
    box-shadow: $shadow-md;
  }

  .ant-tooltip-arrow-content {
    background: $bg-tertiary;
  }
}
</style>